{{value | currency:currencyCode:symbol}}